import { api } from "./api";

export const GetAllProgramsApi = (type: string) => {
  return api.get(`/programs/getAllPrograms/${type}`);
};

export const GetProgramByIdApi = (prog_id: string) => {
  return api.get(`/programs/getProgram/${prog_id}`);
};

export const UpdateProgramByIdApi = (data: any) => {
  return api.post(`/programs/updateProgram`, data);
};

// Company Calendar
export const GetAllPublishedProgramsApi = () => {
  return api.get(`/programs/getAllPublishedPrograms`);
};

/**
 * The admin month view — `POST /programs/adminCalendar` with `{ year, month }`.
 *
 * Returns `data.days[]`, one entry per day of the month (every day, including
 * empty ones), each with `programs[]` and `sessions[]`. Replaces
 * `GET /programs/getProgramsByMonth`, which returned only the days that had
 * programs and knew nothing about appointments.
 */
export const GetProgramsByMonthApi = (year: number, month: number) => {
  return api.post(`/programs/adminCalendar`, { year, month });
};

export const SetAvailDateApi = (data: { prog_id: string; available_date: string }) => {
  return api.post(`/programs/setAvailDate`, data);
};

export const SetBlockDateApi = (data: { prog_id: string; blocked_date: string }) => {
  return api.post(`/programs/setBlockDate`, data);
};
